import {convertDbSizeToBytes} from 'shared';
import {z} from 'zod';

export enum BillingFrequency {
  Monthly = 1,
  Annual = 2,
}
export enum LicenseType {
  Gpx = 0,
  ImageCount = 1,
}

export const companySchema = z.object({
  id: z.string(),
  name: z.string(),
  address: z.string(),
  website: z.string(),
  created: z.coerce.date(),

  license: z.object({
    start: z.coerce.date(),
    expiry: z.coerce.date(),
    frequency: z.enum(BillingFrequency),

    seats: z.object({
      used: z.number(),
      allowed: z.number(),
    }),

    data: z.object({
      used: z.number(),
      allowed: z.number(),
      type: z.enum(LicenseType),
    }),

    supplementary: z.object({
      used: z
        .number() // MB
        .nonnegative()
        .transform((n) => convertDbSizeToBytes(n, 'collection')),
      allowed: z
        .number() // MB
        .nonnegative()
        .transform((n) => convertDbSizeToBytes(n, 'collection')),
    }),
  }),
});
